import * as Sentry from "@sentry/gatsby";

Sentry.init({
  dsn: "https://7fd393160cf3cd42368faec08cff528a@o4509000740765696.ingest.us.sentry.io/4509000742338560"
});
